<div class="myPurchase-dialog-container">
  <!-- <div class="innerDiv"> -->
  <div class="myPurchase-dialog-header heading-h6-regular">
    {{ input.headerTitle }}
  </div>
  <div class="myPurchase-dialog-content">
    <div class="toggle-div">
      <!-- <h1 class="header-dialog">{{ input.headerTitle }}</h1> -->
      <h1 class="buttons-header paragraph-medium-regular">{{ input.buttonsHeader }}</h1>
      <mat-button-toggle-group [(ngModel)]="selected" class="toggle-button-group" (ngModelChange)="toggle()"  #togglebutton3>
        <mat-button-toggle style="line-height:0px; padding-top:2px" value="UP_TO_6K" class="toggle-button" [checked]=true>Up to $6k</mat-button-toggle>
        <mat-button-toggle style="line-height:0px;padding-top:2px" value="ABOVE_6K_BELOW_200k" class="toggle-button" [checked]="isChecked">>$6k, up to $200k</mat-button-toggle>
        <mat-button-toggle style="padding-top:6px" value="ABOVE_200k" [checked]="isChecked">Above $200k<br><mat-hint class="hint">(To be handled by contracts team)</mat-hint></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <form>
      <h1 class="dropDown-header paragraph-medium-regular">{{ input.dropDownHeader }}</h1>
      <mat-form-field style="width:400px">
        <mat-label>Please select an option</mat-label>
        <mat-select name="Please select an option" panelWidth="400px" [(ngModel)]="dropDownOptionId"
          (ngModelChange)="dropDownSelected()">
          <mat-option *ngFor="let element of currentDropDown" [value]="element['id']">
            {{element['value']}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'radio' || this.selectedRadioButtonKey !== undefined || this.selectedRadioButtonKey === 'radio'">
      <div class="example-selected-value paragraph-medium-regular">{{this.selectedDropDownOption['radioButtonHeader']}}</div>
      <mat-radio-group class="radio-button-group" [(ngModel)]="this.selectedRadioButton"
        (ngModelChange)="radioButtonSelected()">
        <mat-radio-button class="radio-button" *ngFor="let option of this.currentRadioButtons" [value]="option['id']">
          {{option['value']}}
        </mat-radio-button>
      </mat-radio-group>
    </ng-template>
    <ng-template [ngIf]="this.selectedRadioButtonKey === 'radio' || this.selectedInnerRadioButtonKey !== undefined">
      <div class="example-selected-value paragraph-medium-regular">{{this.currentInnerRadioButtonsHeader}}</div>
      <mat-radio-group class="radio-button-group" [(ngModel)]="this.selectedInnerRadioButtonKey">
        <mat-radio-button class="radio-button" *ngFor="let option of this.currentInnerRadioButtons"
          [value]="option['key']">
          {{option['value']}}
        </mat-radio-button>
      </mat-radio-group>
    </ng-template>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'RFQ' || this.selectedRadioButtonKey === 'RFQ' || this.selectedInnerRadioButtonKey === 'RFQ'">
      <img src="/assets/images/RFQ.svg" alt="image" class="image">
    </ng-template>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'CWCT' || this.selectedRadioButtonKey === 'CWCT' || this.selectedInnerRadioButtonKey === 'CWCT'">
      <img src="/assets/images/CWCT.svg" alt="image" class="image">
    </ng-template>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'SVP' || this.selectedRadioButtonKey === 'SVP' || this.selectedInnerRadioButtonKey === 'SVP'">
      <img src="/assets/images/SVP.svg" alt="image" class="image">
    </ng-template>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'CCCP'  || this.selectedRadioButtonKey === 'CCCP' || this.selectedInnerRadioButtonKey === 'CCCP'">
      <img src="/assets/images/CCCP.svg" alt="image" class="image">
    </ng-template>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'PCPO'  || this.selectedRadioButtonKey === 'PCPO' || this.selectedInnerRadioButtonKey === 'PCPO'">
      <img src="/assets/images/PCPO.svg" alt="image" class="image">
    </ng-template>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'T'  || this.selectedRadioButtonKey === 'T' || this.selectedInnerRadioButtonKey === 'T'">
      <img src="/assets/images/T.svg" alt="image" class="image">
    </ng-template>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'MMS'  || this.selectedRadioButtonKey === 'MMS' || this.selectedInnerRadioButtonKey === 'MMS'">
      <img src="/assets/images/MMS.svg" alt="image" class="image">
    </ng-template>
    <ng-template
      [ngIf]="this.selectedDropDownOptionKey === 'DC'  || this.selectedRadioButtonKey === 'DC' || this.selectedInnerRadioButtonKey === 'DC'">
      <img src="/assets/images/DC.svg" alt="image" class="image">
    </ng-template>
    <!-- </div> -->
  </div>
  <div class="myPurchase-dialog-actions">
    <div mat-dialog-actions class="bottom-button-group">
      <app-button class="padBtn" mat-dialog-close name="Close"></app-button>
      <ng-template [ngIf]="this.selectedDropDownOptionKey !== 'MMS' && this.selectedDropDownOptionKey !== 'SVP' && this.selectedRadioButtonKey !=='CWCT'"><app-button class="padBtn actionBtn" type="flat-button" [routerLink]="getLink()" (click)="closeModal()" name="Proceed"></app-button></ng-template>
      <ng-template [ngIf]="this.selectedDropDownOptionKey === 'MMS' || this.selectedDropDownOptionKey === 'SVP' || this.selectedRadioButtonKey ==='CWCT'"><app-button class="padBtn actionBtn" type="flat-button" (click)="getExternalLinks()" name="Proceed"></app-button></ng-template>
    </div>
  </div>
</div>